<div class="container-tig">
    <div class="details-nav">
        <ul class="d-flex">
            <li>
                <a [routerLink]="['/Download']">字体下载</a>
            </li>
            <li class="details-active">/</li>
            <li class="details-active">蒙古文无衬线报体</li>
        </ul>
    </div>
    <!-- 字体样式 component -->
    <div class="Font-style-debugger">
        <div class="font-component row " [ngClass]="{'row-clos-md-2': sm , 'row-clos-md-3': !sm }" id="">
            <div class="In_box" id="InBox">
                <div class="inIcon " (click)="OpenClose()">
                    <svg width="1em" height="1em" id="iconPan" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                </div>
                <div class="mgl position-relative " style="z-index: 2;">
                    <span class="position-absolute">
                        <input type="text" maxlength="30" class="inText font-oss" id="In" placeholder="输入文字，即时体验" [(ngModel)]="inText"> 
                    </span>
                </div>
            </div>
            <div class="col d-flex align-items-center justify-content-lg-center padding-left-48">
                <div class="font_resize">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="sm-t" (click)="smFs()">
                            <span class="big-t" id="bt">T</span>
                            <span class="min-t" id="mt">T</span>
                        </div>
                    </div>
                </div>
                <span *ngIf="!sm" class="font-size-slider w-100">
                    <ng5-slider [(value)]="value" [options]="options"></ng5-slider>
                </span>
            </div>
            <div class="col d-flex justify-content-center align-items-center ">
                <div class="color-icon position-relative">
                    <input type="color" class="color-b position-absolute" [(ngModel)]="bgColor">
                    <input type="color" class="color-w position-absolute" [(ngModel)]="color">
                </div>
                <div class="reset" (click)="Reset()">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-clockwise" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                </div>
            </div>
            <div class="col d-flex align-items-center justify-content-end">
                <div class="d-help">
                    <a [routerLink]="['/usageMethod/install']">
                    安装指南
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class=" cont-item text-center  home-t-item ">

        <div class="overflow-hidden position-relative" [ngStyle]="Color()">
            <div class="Asthenia-left position-absolute" [ngStyle]="LastheniaColor()"></div>
            <div class="Asthenia-right position-absolute" [ngStyle]="RastheniaColor()"></div>
            <div *ngIf="text !== ''" class="d-flex justify-content-center align-items-start w-100" [ngStyle]="getHeight()">
                <span class="mgl" [ngStyle]="font_size()" style="padding: 15px 0;">
                    {{ text }}
                </span>
            </div>
            <div *ngIf="text === ''" class=" d-flex justify-content-center font-oss text-details" [ngStyle]="font_size()" #inHeight>
                <P class="mgl"> </P>
                <P class="mgl text-right" style="margin: 0 10px;">  </P>
                <P class="mgl" style="margin-right: 10px;">     
                    <br>      
                    <br>     
                    <br>      
                    <br>   
                    <br>    
                </P>
                <P class="mgl">
                       
                    <br>      
                    <br>    
                    <br>    
                    <br>   
                    <br>    
                </P>
            </div>
        </div>
    </div>
    <div class="details-item-title">
        <h4>蒙古文无衬线报体</h4>
        <div>
            <ul>
                <li>
                    <a class=" Download" href="/assets/FontPack/OnonSoninSans.zip">
                        <span class="d-text">
                            下载 
                        </span>
                        <span class="d-icon">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-down-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="details-container d-flex flex-wrap row row-cols-1 row-cols-sm-2 row-cols-md-3 cont-item">
        <div class="details-container-item col">
            <h4>True Type(.ttf)：</h4>
            <br>
            <p>.ttf字体是Windows和Mac的最常见的字体，是一种RAW格式，因此他不为网站优化,支持这种字体的浏览器有【IE9+, Firefox3.5+, Chrome4+, Safari3+, Opera10+, iOS Mobile Safari4.2+】；</p>
        </div>
        <div class="details-container-item col">
            <h4>Open Type(.otf)：</h4>
            <br>
            <p>.otf字体被认为是一种原始的字体格式，其内置在TrueType的基础上，所以也提供了更多的功能,支持这种字体的浏览器有【Firefox3.5+, Chrome4.0+, Safari3.1+, Opera10.0+, iOS Mobile Safari4.2+】；</p>
        </div>
        <div class="details-container-item col">
            <h4>Web Open Font Format (.woff)：</h4>
            <br>
            <p>.woff字体是Web字体中最佳格式，他是一个开放的TrueType/OpenType的压缩版本，同时也支持元数据包的分离,支持这种字体的浏览器有【IE9+, Firefox3.5+, Chrome6+, Safari3.6+, Opera11.1+】；</p>
        </div>
        <div class="details-container-item col">
            <h4> Embedded Open Type (.eot)：</h4>
            <br>
            <p>.eot字体是IE专用字体，可以从TrueType创建此格式字体,支持这种字体的浏览器有【IE4+】；</p>
        </div>
        <div class="details-container-item col">
            <h4> SVG(.svg)：</h4>
            <br>
            <p>.svg字体是基于SVG字体渲染的一种格式,支持这种字体的浏览器有【Chrome4+, Safari3.1+, Opera10.0+, iOS Mobile Safari3.2+】。</p>
        </div>
    </div>
</div>